import Settings from '../Settings'
import Svgator from './Svgator'

const Properties = {
    init() {
        if (!this.cacheDom()) return

        this.mq = window.matchMedia(Settings.propertyIconInTitleMq)
        this.placeIcons()
        this.bindPlayers()
        this.bindEvents()
    },

    cacheDom() {
        this.rows = Array.from(document.querySelectorAll('.property-ping-pongs .ping-pong'))
        return this.rows.length > 0
    },

    bindEvents() {
        this.mq.addEventListener('change', this.placeIcons.bind(this))
    },

    bindPlayers() {
        this.rows.forEach((row) => {
            const svg = row.querySelector('.ppp-icon svg')
            if (svg) Svgator.bind(svg)
        })
    },

    placeIcons() {
        const toTitle = this.mq.matches

        this.rows.forEach((row) => {
            const icon = row.querySelector('.ppp-icon')
            const title = row.querySelector('.ppp-title')
            const footer = row.querySelector('.ppp-footer')
            if (!icon || !title || !footer) return

            const destination = toTitle ? title : footer
            if (icon.parentElement !== destination) {
                destination.append(icon)
            }
        })
    },
}

export default Properties
